module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-input",
    class: _vm.classes()
  }, [_c('v-flex', {
    staticClass: "input-group__input"
  }, [_c('label', {
    class: _vm.classesLabel()
  }, [_vm._v(_vm._s(_vm.label) + " ")]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return [_c('v-flex', {
      staticClass: "set-field v-list--dense",
      attrs: {
        "px-2": ""
      },
      on: {
        "click": function($event) {
          return _vm.onClick(item)
        }
      }
    }, [(item[_vm.itemTitle] || item[_vm.itemDate]) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs9": "",
        "sm10": ""
      }
    }, [_c(_vm.createComp(_vm.getField(item, _vm.itemTitle)), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "v-list__tile__action-text",
      staticStyle: {
        "display": "block",
        "text-align": "end",
        "white-space": "normal"
      },
      attrs: {
        "xs3": "",
        "sm2": "",
        "align-end": ""
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.formatDateTime(_vm.getField(item, _vm.itemDate))))])])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
      staticClass: "v-list__tile__sub-title",
      staticStyle: {
        "white-space": "normal"
      },
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_c(_vm.getField(item, _vm.itemText) || _vm.createComp(Object.values(item)[0]), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-flex', {
      staticStyle: {
        "text-align": "end"
      }
    }, [_c(_vm.renderIcons(_vm.getField(item, _vm.itemIcons)), {
      tag: "v-component"
    })], 1)], 1)], 1)]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52fe7616","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ItemsField.vue
// module id = 839
// module chunks = 1